module.exports = __webpack_public_path__ + "xzzz.png?002f1b10838d1e198db1caf00156817c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xzzz.png
// module id = 623
// module chunks = 0